
const UrlApi = process.env.REACT_APP_API_URL || 'https://starprev.starttec.com.br'; // Demo



export default UrlApi
